import { render } from "./Tokenomics.vue?vue&type=template&id=76c2334a&scoped=true"
import script from "./Tokenomics.vue?vue&type=script&lang=js"
export * from "./Tokenomics.vue?vue&type=script&lang=js"

import "./Tokenomics.vue?vue&type=style&index=0&id=76c2334a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c2334a"]])

export default __exports__